<template>
    <CCardGroup style="height: 100vh;">
        <CCard
            class="background-image"
        >
        </CCard>
        <CCard class="p-4">
            <CCardBody>
                <CForm @submit.prevent="login">
                    <CRow class="justify-content-center">
                        <CCol md="10" sm="12" style="margin:50px" class="text-center">
                            <img src="@/assets/images/logo_nomina.png" align="center" width="30%"/>
                        </CCol>
                        <CCol md="10" sm="12">
                            <h1>{{$t('login.label')}}</h1>
                            <p class="text-muted">{{$t('login.sigin')}}</p>
                            <CInput
                                type="email"
                                v-model="email"
                                :placeholder="$t('login.input.email.placeholder')"
                                required="required"
                                :title="$t('login.input.email.required')"
                            >
                                <template #prepend-content><CIcon name="cil-user"/></template>
                            </CInput>
                            <CInput
                                v-model="password"
                                :placeholder="$t('login.input.password.placeholder')"
                                type="password"
                                required="required"
                                :title="$t('login.input.password.required')"
                            >
                                <template #prepend-content><CIcon name="cil-lock-locked"/></template>
                            </CInput>
                            <CRow>
                                <CCol col="4" class="text-center">
                                    <CButton 
                                        type="submit" 
                                        color="primary" 
                                        class="px-4"
                                    >{{$t('login.entry')}}</CButton>
                                </CCol>
                                <CCol col="4" class="text-center">
                                    <a 
                                        class="btn btn-warning"
                                        href="/charges"
                                        style="color:white"
                                    >{{$t('charges.title')}}</a>
                                </CCol>
                                <CCol col="4" class="text-center">
                                    <a 
                                        class="btn btn-success"
                                        href="/register"
                                        color="success" 
                                    >{{$t('login.register')}}</a>
                                </CCol>
                            </CRow>
                        </CCol>
                    </CRow>
                </CForm>
            </CCardBody>
        </CCard>
    </CCardGroup>
</template>

<script>
import axios from "axios";
import store from '../store'

export default {
    name: 'Login',
    data() {
        return {
            email: '',
            password: ''
        }
    },
    methods: {
        setConfigureNotifications() {
            /*
            const messaging = getMessaging();
            let self = this;

            getToken(messaging, { vapidKey: 'BJ0ChfzoEviSMmPThhV7FCKzfe8U2zd-Vhcs0q5XNC9v6a9PvDzMI5vhL87dZoTL1PWPoszTqfmmLZQkzBrOxRY' })
                .then((currentToken) => {
                if (currentToken)  {
                    const token = localStorage.getItem('token', null);

                    axios.post('/users/token', {
                        token: currentToken,
                    }, {
                        headers: {
                            'Authorization': `Bearer ${token}`,
                        }
                    }).then(response => {
                        //console.log(response);
                        self.$router.push({ path: '/charges' });
                    }).catch(error => {
                        self.$router.push({ path: '/charges' });
                        self.$toast.error(error.response.data.message);
                    });
                } else {
                    // Show permission request UI
                    console.log('No registration token available. Request permission to generate one.');
                    self.$router.push({ path: '/charges' });
                    // ...
                }
            }).catch((err) => {
                console.log('An error occurred while retrieving token. ', err);
                self.$router.push({ path: '/charges' });
                // ...
            });
             */

            let self = this;
            window.location.href = '/charges';
            console.log("entra");
            //self.$router.push({ path: '/charges'  });
        },
        login() {
            let self = this;

            axios.post('/auth/login', {
                email: self.email,
                password: self.password,
            }).then(response => {
                if (response.data.success) {
                    localStorage.setItem('login', true);
                    localStorage.setItem('token', response.data.token);
                    store.dispatch('setUser', response.data);
                    self.getConfiguration();

                    axios.get('/user', {
                        headers: {
                            'Authorization': `Bearer ${response.data.token}`,
                        }
                    })
                    .then(response => {
                        store.dispatch('setUser', response.data);
                    }).catch(() => {
                        store.dispatch('setUser', null);
                    });

                    this.setConfigureNotifications();

                } else {
                    self.$toast.error(response.data.message);
                }
            }).catch(error => {
                self.$toast.error(error.response.data.message);
            });
        },
        getConfiguration() {
            axios.post('/configuration', {
                version: 0,
            }).then(response => {
                store.dispatch('setConfiguration', response.data);
            }).catch(error => {
                this.$toast.error(error.response.data.message);
            });
        }
    },
    mounted() {
        localStorage.clear();
    }
}
</script>

<style>
    .background-image {
        background-image: url('~@/assets/images/background.jpg');
        background-size: cover;
    }
</style>
